import { render, staticRenderFns } from "./XPassword.vue?vue&type=template&id=e1959bec"
import script from "./XPassword.vue?vue&type=script&lang=js"
export * from "./XPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports